module.exports = __webpack_public_path__ + "imgs/LastPrisonerProject.fd60f3a089c2cb6a8d619e313db1c562.png";